import { useIntl } from 'react-intl'

export function useInsuranceProductsData() {
  const intl = useIntl()

  return [{
    type: intl.formatMessage({ id: 'dM/bzPH/Aj', defaultMessage: 'International Escapes', description: 'Product category type for international insurance plans on landing page' }),
    title: intl.formatMessage({ id: 'so/d+rOYyA', defaultMessage: 'Comprehensive Trip Protection', description: 'Product title for comprehensive international travel insurance on landing page' }),
    benefits: [
      {
        text: intl.formatMessage({ id: 'W7qdRoLN+z', defaultMessage: 'Refund bookings for you or your ticket holders at anytime if need to cancel due to illness or injury,', description: 'Benefit description for booking refund coverage in comprehensive trip protection' }),
        includingCovid: true,
      },
      {
        text: intl.formatMessage({ id: 'lRAV7vlhlH', defaultMessage: 'Medical assistance and treatment,', description: 'Benefit description for medical assistance in comprehensive trip protection' }),
        includingCovid: true,
      },
      {
        text: intl.formatMessage({ id: 'enlaZZ2+PE', defaultMessage: 'Money back for emergency expenses, including accommodation, transport and food', description: 'Benefit description for emergency expense coverage in comprehensive trip protection' }),
        includingCovid: false,
      },
      {
        text: intl.formatMessage({ id: 'rn658SjU3r', defaultMessage: 'Cover for damaged or stolen personal items', description: 'Benefit description for personal items coverage in comprehensive trip protection' }),
        includingCovid: false,
      },
    ],
    complementaryText: intl.formatMessage({ id: 'Zion3n/70/', defaultMessage: 'Not covered: Pre-existing medical conditions.', description: 'Exclusion note for comprehensive trip protection plan' }),
  }, {
    type: intl.formatMessage({ id: 'dM/bzPH/Aj', defaultMessage: 'International Escapes', description: 'Product category type for international insurance plans on landing page' }),
    title: intl.formatMessage({ id: 'iX7EKwSmSu', defaultMessage: 'Overseas Medical and Evacuation', description: 'Product title for overseas medical and evacuation insurance on landing page' }),
    benefits: [
      {
        text: intl.formatMessage({ id: 'ndmy2gGURO', defaultMessage: 'Medical assistance and treatment during your trip,', description: 'Benefit description for medical treatment in overseas medical plan' }),
        includingCovid: true,
      },
      {
        text: intl.formatMessage({ id: 'b40sUD6UrL', defaultMessage: 'Emergency flights and evacuation', description: 'Benefit description for emergency evacuation in overseas medical plan' }),
        includingCovid: false,
      },
      {
        text: intl.formatMessage({ id: 'WR1o70ujs2', defaultMessage: 'Money back for emergency expenses, including accommodation, transport and food,', description: 'Benefit description for emergency expense coverage in overseas medical plan' }),
        includingCovid: true,
      },
    ],
    complementaryText: intl.formatMessage({ id: 't8be3Krh8+', defaultMessage: 'Please note: This cover will not allow a refund if you or another person you’re travelling with needs to cancel your trip prior to departure due to illness or injury', description: 'Important notice about cancellation limitations for overseas medical plan' }),
  }, {
    type: intl.formatMessage({ id: '/qutlCQ/Lz', defaultMessage: 'Domestic Escapes', description: 'Product category type for domestic insurance plans on landing page' }),
    title: intl.formatMessage({ id: 'RE566NQN3u', defaultMessage: 'Cancellation and Baggage protection', description: 'Product title for domestic cancellation and baggage insurance on landing page' }),
    blurb: intl.formatMessage({ id: 'kCOMiEYCHU', defaultMessage: 'If any travellers need to cancel or cut short the trip due to the illness or death of yourself or a close family member...', description: 'Description blurb for domestic cancellation and baggage protection plan' }),
    benefits: [
      {
        text: intl.formatMessage({ id: 'lRD5rN+oMs', defaultMessage: 'your Luxury Escapes package costs will be reimbursed.', description: 'Benefit description for cost reimbursement in domestic protection plan' }),
        includingCovid: false,
      },
      {
        text: intl.formatMessage({ id: 'ACcPCSiPuq', defaultMessage: 'cover for damaged or stolen personal items.', description: 'Benefit description for personal items coverage in domestic protection plan' }),
        includingCovid: false,
      },
      {
        text: intl.formatMessage({ id: '4RvSPJnGRd', defaultMessage: 'payments are made instantly into your currency and bank account.', description: 'Benefit description for instant payments in domestic protection plan' }),
        includingCovid: false,
      },
    ],
  }]
}
